import React, {useEffect, useState} from "react";
import Sidebar from "./Sidebar";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

// import CountdownTimer from "../common/Countdown";
export default function Account({ onLoaded }) {

    const { logout, user, loading} = useAuth();
    const navigate = useNavigate();




    useEffect(() => {
        // user varsa ya da auth yüklemesi bittiyse (loading === false) sayfayı hazır say
        if (user || !loading) onLoaded?.();
    }, [user, loading]);


    const handleLogout = () => {
        logout();
        navigate("/");
    };

    const fullName = `${user?.firstName || ""} ${user?.lastName || ""}`; // 👈 Ad Soyad birleştirme

    return (
        <div className="main-content-account">
            {/* Breadcrumb */}
            <div className="tf-breadcrumb">
                <div className="container">
                    <ul className="breadcrumb-list">
                        <li className="item-breadcrumb">
                            <Link to={`/`} className="text">
                                Home
                            </Link>
                        </li>
                        <li className="item-breadcrumb dot">
                            <span />
                        </li>
                        <li className="item-breadcrumb">
                            <span className="text">Account</span>
                        </li>
                    </ul>
                </div>
            </div>
            {/* /Breadcrumb */}
            {/* Title Page */}
            <section className="s-title-page">
                <div className="container">
                    <h4 className="s-title letter-0 text-center">My Account</h4>
                </div>
            </section>
            {/* /Title Page */}
            {/* sidebar-account */}
            <div className="btn-sidebar-mb d-lg-none">
                <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" data-bs-backdrop="false">
                    <i className="icon icon-sidebar" />
                </button>
            </div>
            {/* /sidebar-account */}
            {/* Section-acount */}

            <section className="flat-spacing-2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="my-account-container">
                                <div className="sidebar-account-wrap sidebar-content-wrap sticky-top d-lg-block d-none">
                                    <ul className="my-account-nav">
                                        <Sidebar />
                                    </ul>
                                </div>
                                <div className="my-acount-content account-dashboard">
                                    <div className="box-account-title">
                                        <p className="hello-name display-sm fw-medium">
                                            Hello {fullName}!{" "}
                                            <span>
                                                (not <span className="name">{fullName}</span>{" "}?
                                            </span>{" "}
                                            <Link onClick={handleLogout} className="text-decoration-underline link">
                                                Log Out
                                            </Link>
                                            <span>)</span>
                                        </p>
                                    </div>

                                    <div className="content-account">
                                        <ul className="box-check-list flex-sm-nowrap">
                                            <li>
                                                <Link
                                                    to={`/account-orders`}
                                                    className="box-check text-center"
                                                >
                                                    <div className="icon">
                                                        <i className="icon-order"/>
                                                        {/*<span className="count-number text-sm text-white fw-medium">*/}
                                                        {/*  1*/}
                                                        {/*</span>*/}
                                                    </div>
                                                    <div className="text">
                                                        <div className="link name-type text-xl fw-medium">
                                                            Orders
                                                        </div>
                                                        <p className="sub-type text-sm">
                                                            Check the history of all your orders
                                                        </p>
                                                    </div>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to={`/account-details`}
                                                    className="box-check text-center"
                                                >
                                                    <div className="icon">
                                                        <i className="icon-user"/>
                                                    </div>
                                                    <div className="text">
                                                        <div className="link name-type text-xl fw-medium">
                                                            Account Details
                                                        </div>
                                                        <p className="sub-type text-sm">
                                                            Update your personal info
                                                        </p>
                                                    </div>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    onClick={handleLogout}
                                                    className="box-check text-center"
                                                >
                                                    <div className="icon">
                                                        <img
                                                            src="https://img.icons8.com/?size=100&id=16570&format=png&color=000000"
                                                            alt="Logout"
                                                            width={45}
                                                            height={45}
                                                        />
                                                    </div>
                                                    <div className="text">
                                                        <div className="link name-type text-xl fw-medium">
                                                            Logout
                                                        </div>
                                                        <p className="sub-type text-sm">
                                                            Sign out of your account
                                                        </p>
                                                    </div>
                                                </Link>
                                            </li>
                                        </ul>
                                        <div className="banner-account">
                                            <div className="image">
                                                <img
                                                    src="/images/banner/account-1.jpg"
                                                    data-=""
                                                    alt=""
                                                    className="lazyload"
                                                    width={912}
                                                    height={280}
                                                />
                                            </div>
                                            <div className="banner-content-right">
                                                <div className="banner-title">
                                                    <p className="display-md fw-medium">Time for Shopping!</p>
                                                    <p className="text-md">Checkout our latest products now.</p>
                                                </div>
                                                <div className="banner-btn">
                                                    <Link
                                                        to={`/product-list`}
                                                        className="tf-btn animate-btn"
                                                    >
                                                        Shop Now
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* /Account */}
        </div>
    );
}
